import { httpPost } from "../utils/http";
import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getCsvData(reportID, type) {
    let data = { type: type };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/csv/${Crypto.encrypt(reportID, CryptoKey)}`;
    return httpPost(apiUrl, data);
  }

  getUserCsvData(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/csv/user`;
    return httpPost(apiUrl, data);
  }
}
